import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';
import { deleteDoc, doc } from 'firebase/firestore';

import { db } from '../../config';

const COLLECTION_PATH = 'client-request';

type Params = { id: string };

export const useDeleteClientRequestFromFirestore = (
  options?: UseMutationOptions<Params, FirebaseError, Params>,
): UseMutationResult<Params, FirebaseError, Params> => useMutation<Params, FirebaseError, Params>({
  mutationFn: async ({ id }) => {
    if (!id) throw new Error('Brak id zgłoszenia');
    await deleteDoc(doc(db, COLLECTION_PATH, id));
    return { id };
  },
  ...options,
});
